<nav
    class="navbar-expand-md navbar navbar-inverse bg-inverse justify-content-center align-items-center fixed-top navbar-expand-xl navbar-light bg-light mb-5">

    <button id="menuToggle" class="navbar-toggler " type="button" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation" (click)="moveUserArea()">
        <img class="logout" src="assets/images/menu-i.png" />
    </button>

    <a class="navbar-brand logo" href="https://enativ.com">
        <img src="../../../assets/images/new-nativ-logo.png" target="_blank" width="30" height="30" class="d-inline-block align-top" alt="">
    </a>

    <div  class="date">
        <span *ngIf="heDate">{{heDate}}</span>
        <span>{{date | date:'dd/MM/yyyy'}}</span>
    </div>

    <div class="collapse navbar-collapse navbar" id="navbarSupportedContent">
        <ul>
            <li class="nav-item">
                <a class="nav-link" (click)="closeMenu()" [ngClass]="url==='/last-videos'?'cuurent-link' :''"
                    routerLink="../last-videos">בית</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="closeMenu()" [ngClass]="url==='/favorites'?'cuurent-link':''"
                    routerLink="../favorites">מועדפים</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="closeMenu()" [ngClass]="url==='/history'?'cuurent-link':''"
                    routerLink="../history">היסטוריה</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="closeMenu()" [ngClass]="url==='/my-videos'?'cuurent-link':''"
                    routerLink="../my-videos">הסרטונים
                    שלי</a>
            </li>
        </ul>
    </div>

    <div id="user-area">
        <button (click)="logout()"class="last-item logout-button" title="החלף משתמש">
        <div class="navbar-brand last-item text">
            <div id="user-name">
                {{userName}}
            </div>

        </div>
            <img  class="logout" src="../../../assets/images/exit-icon.png" alt="יציאה">
        </button>
    </div>


</nav>